<div class="resolutions-holder">
  <div class="top-holder">
    <h3 class="resolutions-header"><img src="assets/arrow-left.svg" class="backCandidates" (click)="back()">{{liveQuestion.title}}</h3>
  </div>
  <app-list-candidate-item *ngFor="let choice of pollChoices; let i = index" [index]="i" [choice]="choice"></app-list-candidate-item>
</div>
